<template>
    <el-dialog
        style="padding: 0 20px 20px 20px !important;"
        width="80%"
        title="上传SP关键词搜索趋势列表"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form ref="ruleForm" :inline="true" class="query-form" size="mini" :model="query">
            <el-form-item label="国家：" class="query-form-item" prop="state">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 100px;"
                    size="mini"
                    filterable
                    clearable
                    @change="getList"
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled"
                    >
                        <div class="keywords_arr_div">
                            <icon-svg
                                :icon-class="item.us"
                                style="font-size: 24px;margin-right:5px;"
                            ></icon-svg>
                            <span
                                style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                            >{{ item.title }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
                <!--                <el-button type="success" icon="el-icon-plus" @click="uploadFile">上传文件</el-button>-->
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            border
            style="width: 100%"
        >
            <el-table-column label="ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="国家" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.state }}</div>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="月份" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.month || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="源文件名" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.filename || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="上传标记值" min-width="150" align="center">
                <template slot-scope="scope">
                    <el-button style="margin: 5px 0 5px 10px" type="success" @click="downFile(scope.row.source_path)" size="mini">下载源文件</el-button>
                    <el-button v-if="scope.row.status == '0'" size="mini" style="margin: 5px 0 5px 10px">待解析</el-button>
                    <el-button v-if="scope.row.status == '1'" size="mini" style="margin: 5px 0 5px 10px">解析中</el-button>
                    <el-button type="success" v-if="scope.row.status == '2'" size="mini" style="margin: 5px 0 5px 10px">解析完成</el-button>
                    <el-button type="danger" v-if="scope.row.status == '-1'" size="mini" style="margin: 5px 0 5px 10px">解析失败</el-button>
                    <el-button type="danger" @click="showErrorInfo(scope.row)" v-if="scope.row.status == '-1'" size="mini" style="margin: 5px 0 5px 10px">查看失败原因</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[10, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; margin-bottom: 5px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </el-row>
        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息" v-if="errorInfoShow"
                   :visible.sync="errorInfoShow" append-to-body>
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import {sp_ad_upload_source_file_list, keyword_search_upload_source_file_list} from '@/api/Product/Product'
    import {downloadFileUrl} from '@/utils/method'

    export default {
        name: 'uploadFileListDialog',
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                errorInfoShow: false,
                tableHeight: null,
                query: {
                    page: 1,
                    limit: 10,
                    state: '',
                },
                loading: false,
                errorMsg: '',
                currentId: '',
                ctrl: {
                    addRecordDialogVisible: false
                },
                list: [],
                us_arr: [
                    {
                        us: 'US',
                        title: '美国'
                    },
                    {
                        us: 'UK',
                        title: '英国'
                    },
                    {
                        us: 'DE',
                        title: '德国'
                    }
                ],
            }
        },
        watch: {
            'visible': {
                handler(flag){
                    flag && this.getList()
                }
            }
        },
        methods: {
            //查询
            onSubmit() {
                this.getList()
            },
            onReset() {
                this.query.page = 1
                this.query.limit = 20
                this.getList()
            },
            searchForm() {
                this.getList()
            },
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.error_message
            },
            async startDecode(row, force = 0) {
                if (force) {
                    await this.$confirm('是否重新运行解析任务', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }
                let list = JSON.parse(JSON.stringify(this.list))
                api.reduce_bid_parsing_file({
                    id: row.id,
                    force
                }).then(() => {
                    const index = list.findIndex(item => item.id === row.id)
                    list[index].status = 1
                    this.list = list
                })
            },
            getList() {
                this.loading = true
                keyword_search_upload_source_file_list(this.query).then(res => {
                    if (res.code === 0) {
                        this.list = res.data.list
                        this.query.total = res.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.$emit('close-callback', isshow)
            },
            addRecords() {
                this.ctrl.addRecordDialogVisible = true
            },
            delete_records(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.out_three_page_delete({id: data.id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            closeCllback() {
                this.ctrl.addRecordDialogVisible = false
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            downFile(path) {
                if (!path) {
                    return this.$message({type: 'error', message: '无法下载！'})
                }
                downloadFileUrl(path)
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ .el-card__header {
        padding: 14px 20px !important;
    }

    /deep/ .el-tabs__content {
        overflow: visible !important;
    }

    /deep/ .el-card {
        overflow: visible !important;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell {
        padding: 0 0 !important;
    }
</style>
